<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <h1 class="mb-4">Tardy Management Appointments</h1>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
export default {
  name: "TardyManagementAppointments",
  components: {},
  computed: {}
}
</script>
